import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as api from "../../api";
import { RouteComponentProps } from "react-router-dom";
import Button from "../../Button/Button";
import { isNullOrUndefined } from "../../utils/formatting";

import {
  userChosenDuplicateQuestion,
  userChosenCovidQuestion,
  userChosenContactDetails,
  userChosenContactPhone,
  userChosenContactName,
  userChosenRelationDetails,
  isEditState,
  userChosenAdditionalDescription,
  userChosenVandalismQuestion,
  userChosenVandalismAdditionalInformation,
  userChosenVulnerabilityQuestion,
  userChosenVulnerabilityAdditionalInformation,
  backToRepairAsset,
  resumeDraftRepair,
  userChosenIsReporter,
  userChosenPropertyAddress,
  userResumeData,
  userChosenRepairLocationId,
  userChosenSupplementaryQuestions,
  userChosenEmergencyQuestion,
  userChosenAdditionalDescriptionCOUNT,
  userResumeDraftDataCache,
  userChosenSOR,
  userChosenRepairLocation,
  userChosenHighLevelDescription,
  userChosenResumeRepair,
  loadDuplicateRepairPage,
  userChosenDuplicateEntity,
  workOrderData,
  userChosenSaveExit,
  userChosenNotifyAll,
  setRepairDiagnosticFinalData,
  userChosenEligibilityErrorCode,
  saveAppointmentBundle,
  saveEmailCopyRadioValue,
  isRepairMediaResume,
  woFailureCase
} from "../../ducks/redux/actions/userChoices";
import ExitModalAndSave from "../Modal/ExitModalAndSave";
import { Container, FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import { WorksOrdersResponse } from "../../models/WorksOrders";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";
import { getMaintResp, getRepairResp, saveCustomerDetails, saveCustomerphoneNumber, selectedTenacyType, workOrderRepairObject } from "../../ducks/redux/actions/getAddress";
import { RepairChannel } from "../../models/Repair/RepairChannel";
import "./style.css";
import LoadingSpinner from "../../storybook/LoadingSpinner";
import { RepairStatusField } from "../../models/Repair/Repair";
import { PermissionsList } from "../../models/Permissions";
import { assetByIdDataObject, fetchRepairReasonsSelect, priorityCode, selectedRepairReasonObject, selectedRepairReasonPriorityOverride } from "../../ducks/redux/actions/dashboardReducer.actions";
import { RepairPriorityCode, RepairPriority, RepairPriorityToCodeMap } from "../../models/Repair/CreateRepair";
import RepairJourney from "../RepairJourney";
import { Helper } from "../../utils/Helper/HelperUtil";
import { PriorityCodeAndNames } from "../../models/WorksOrders/PriorityCodeAndNames";
import { saveHazardType, saveHHSRSOption, saveSaverityScore } from "../../ducks/redux/actions/FinancialReferral";
import { resetHazardAssessmentData, saveHHSRSAssessmentCompleted } from "../../ducks/redux/actions/hazardAssessment";


interface DuplicateRepairProps extends RouteComponentProps<any> { }
const DuplicateRepair: React.FC<DuplicateRepairProps> = (props) => {
  let moment = require("moment");
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = React.useState(true);
  const [radiovalue, setRadioValue] = React.useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [closeAfterSaving, setCloseAfterSaving] = useState(false);
  const [error, setError] = useState(false);;
  const [errorMessage, setErrorMessage] = useState("");
  const [isResumeDraftRepair, setIsResumeDraftRepair] = useState(false);
  const [disableContinueforEnhancedEligiblityCheck, setDisableContinueforEnhancedEligiblityCheck] = useState(false);
  const [showError, setShowError] = useState("");
  const [noneOftheDuplicateSelected, setNoneOftheDuplicateSelected] = useState(false);
  const [showHLDescription, setShowHLDescription] = useState(new Array(50).fill(false));
  const [isBackModalOpen, setIsBackModalOpen] = useState(false);
  const priorityCodeValue = useSelector((state: any) => state.dashboardReducer?.formState?.priorityCode);

  const userChosenSORValue = useSelector(
    (state: any) => state.userChoicesReducer?.userChosenSOR
  );
  const EditState = useSelector(
    (state: any) => state.userChoicesReducer?.isEditState
  );
  const IsRecall = useSelector(
    (state: any) => state.userChoicesReducer?.IsRecall
  );
  const workOrderObject = useSelector(
    (state: any) => state.addresses?.workOrderRepair
  );
  const assetDetails = useSelector(
    (state: any) =>
      state.dashboardReducer?.formState?.assetByIdDataObject
  );
  const userChosenAdditionalDescriptionBackButton = useSelector(
    (state: any) => state.userChoicesReducer?.userChosenAdditionalDescription
  );
  const userDuplicateQuestion = useSelector(
    (state: any) => state.userChoicesReducer?.userChosenDuplicateQuestion
  );
  const userChosenDuplicate = useSelector(
    (state: any) => state.userChoicesReducer?.userChosenDuplicateEntity
  );
  const selectedRepairReason = useSelector(
    (state: any) => state.dashboardReducer?.formState?.selectedRepairReasonObject
  );
  const selectedproperty = useSelector(
    (state: any) => state.dashboardReducer?.formState?.tracks[0]?.assetType
  );
  const isEmailRedirect = useSelector(
    (state: any) =>
      state.financialReferral?.woRedirectFromEmail
  );
  const userChosenEmergencyQuestionBackButton = useSelector(
    (state: any) => state.userChoicesReducer?.userChosenEmergencyQuestion
  );
  const vandalismConfigValue = useSelector(
    (state: any) => state.userChoicesReducer?.vandalismtoggleValue
  );
  const covidConfigValue = useSelector(
    (state: any) => state.userChoicesReducer?.isRepairCovidAllowed
  );
  const priority = useSelector(
    (state: any) =>
      state.dashboardReducer?.formState?.selectedRepairReasonPriorityOverride ??
      state.dashboardReducer?.formState?.selectedRepairReasonObject[0]?.priority
  );
  const comingFromConfirmedDampmould = useSelector(
    (state: any) => state.userChoicesReducer?.fromconfirmeddampmould
  );
  const comingFromDampAndMouldAssesment1 = useSelector(
    (state: any) => state.userChoicesReducer?.fromDampAndMouldAssesment1
  );
  const comingFromDampAndMouldAssesment2 = useSelector(
    (state: any) => state.userChoicesReducer?.fromDampAndMouldAssesment2
  );

  const comingFromDampAndMouldAssesment3 = useSelector(
    (state: any) => state.userChoicesReducer?.fromDampAndMouldAssesment3
  );
  const isHHSRSEnabled = useSelector((state: any) => state?.financialReferralReducer?.isHHSRSEnabled)
  const isHHSRSRepairEnabled = useSelector((state: any) => state?.userChoicesReducer?.isHHSRSRepairEnabled);
  const isResumedRepair = useSelector((state: any) => state?.userChoicesReducer?.resumeDraftRepair);
  const savedHazardQuestions = useSelector((state: any) => state.hazard?.hazardQuestions);
  const isResumedAssessmentDuplicate = isResumedRepair === true &&
    isHHSRSRepairEnabled === true && workOrderObject?.isPotentialDuplicate === true &&
    (selectedRepairReason?.[0]?.isHazard === true || selectedRepairReason?.[0]?.isPreAssessmentRequired === true);

  const [duplicateRepairResult, setDuplicateRepairResult] =
    useState<WorksOrdersResponse>();

  const getPermissionsData = useSelector(
    (state: any) => state.userChoicesReducer?.userProfilePermissions
  );


  const isCatalyst = useSelector(
    (state: any) => state.userChoicesReducer?.isCatalystProperty
  );

  let duplicateOverridePermissions = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.workorder_override_duplicate_repairs) >= 0;
  let isHHSRSRole = Array.isArray(getPermissionsData) && getPermissionsData.includes(PermissionsList.update_digital_journey_hhsrs_hazard_repair);

  const isEnhancedRepairEligibilityP360 = useSelector(
    (state: any) => state.userChoicesReducer?.checkEnhancedRepairEligibilityP360
  );
  const choosePriorityOfRepairPermission = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.workorder_choose_priority_of_repair) >= 0;
  const isComesFromMediaPage = useSelector(
    (state: any) => state.userChoicesReducer?.isFromMediaPage
  );
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(woFailureCase(""));
    dispatch(saveAppointmentBundle(null));
    if (userChosenDuplicate !== "") {
      setRadioValue(userChosenDuplicate);
      dispatch(loadDuplicateRepairPage(true));
    }
    else {
      setIsDisabled(true)
    }
    (async () => {
      try {
        const propertiesIds = [];
        if (assetDetails?.id) propertiesIds.push(assetDetails?.id);
        let duplicateRepairStatuses = "Unappointed,Appointed,In Progress,In Diagnosis"
        duplicateRepairStatuses += ',' + RepairStatusField.CatalystDefectTriage
        duplicateRepairStatuses += ',' + RepairStatusField.CatalystTier2Triage
        duplicateRepairStatuses += ',' + RepairStatusField.CatalystEMAStatus
        duplicateRepairStatuses += ',' + RepairStatusField.isPendingAssessment

        const queryParams = {
          propertiesIds,
          sor: userChosenSORValue,
          status: duplicateRepairStatuses,
          isDuplicateCheck: true
        };
        let duplicateRepair = await api.getWorksOrdersApi(queryParams);
        Promise.all([duplicateRepair]).then((results) => {

          const filteredWOExcludingCurrentRepairs = results[0]?.worksOrders.filter(
            repair => repair?.identifiers?.worksOrderIdentifier !== workOrderObject?.id
          )

          const filteredWOExcludingCommunalDrafts = filteredWOExcludingCurrentRepairs?.filter(
            repair => repair?.asset?.type?.assetTypeName === "Property" || repair?.asset?.type?.assetTypeName === "Block" || !(repair?.statuses?.status === "In Diagnosis") || getWOUnderReviewStatus(repair)
          )
          const filteredWOResp = new WorksOrdersResponse(
            {
              "worksOrders": filteredWOExcludingCommunalDrafts,
              "totalCount": filteredWOExcludingCommunalDrafts?.length || 0
            }
          )

          if (filteredWOResp?.totalCount === 0 && isResumedAssessmentDuplicate) {
            setDuplicateRepairResult(filteredWOResp);
            setIsLoading(false);
          }
          else if (filteredWOResp?.totalCount === 0) {
            if (isHHSRSRole && isHHSRSEnabled && !(workOrderObject?.isEnhancedDiagnosticsRepair)) {
              props.history.push("/hhsrs");
              return
            } else {
              props.history.push("/RepairAdditionalDetails");
            }

          }
          else {
            filteredWOResp?.worksOrders?.forEach((wo: any) => {
              if (wo?.job?.description === "Inspect Damp and Mould") {
                wo.job.description = "Investigate damp or mould";
                wo.job.repairReason = "Investigate damp or mould";
              }
            });
            setDuplicateRepairResult(filteredWOResp);
            if (filteredWOResp?.totalCount > 0) {
              setIsLoading(false);
              return;
            } else if (props.history.action === "POP") {
              props.history.goBack();
            } else {
              props.history.push("/RepairAdditionalDetails");
            }
          }
        });

      } catch (error) {
        props.history.push("/GenericError");
      }
    })();
  }, []);

  const handleRadioChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRadioValue(event.target.value);
    setDisableContinueforEnhancedEligiblityCheck(false);
    let outsideContactingHours = false;
    if (isEnhancedRepairEligibilityP360) {
      try {
        setIsDisabled(true);
        const enhancedRepairEligibilityPayload = {
          priority: workOrderObject?.priority,
          sor: userChosenSORValue,
          channel: "ColleagueSelfService",
          userRoles: localStorage.getItem('user_role') || "",
          isPotentialDuplicate:
            event.target.value.split("&")[0] ===
              t("IDT_its_duplicate")
              ? !duplicateOverridePermissions
              : false,
        };
        const repairEnhancedEligibility = await api.postEnhancedRepairEligibility(enhancedRepairEligibilityPayload);
        outsideContactingHours = !repairEnhancedEligibility?.isEligible;
      } catch (error) {
        setShowError(t('SSR001'));
        setDisableContinueforEnhancedEligiblityCheck(true);
        return;
      }
      if (outsideContactingHours) {
        setDisableContinueforEnhancedEligiblityCheck(true);
        setShowError("Duplicate_Repair_SSR056");
        return;
      }
    }
    setIsDisabled(false);
    setError(false);
    setErrorMessage('');

    if (EditState === true) {
      dispatch(userChosenNotifyAll(null));
      dispatch(userChosenCovidQuestion(""));
      dispatch(userChosenVulnerabilityAdditionalInformation(""));
      dispatch(userChosenVulnerabilityQuestion("No"));
      dispatch(userChosenContactDetails(""));
      dispatch(userChosenContactPhone(""));
      dispatch(userChosenContactName(""));
      dispatch(userChosenRelationDetails(""));
      dispatch(isEditState(false));

      if (!IsRecall) {
        dispatch(userChosenVandalismAdditionalInformation(""));
        dispatch(userChosenVandalismQuestion("No"));
        dispatch(userChosenAdditionalDescription(""));
      }
    }
    setError(true);
    setIsDisabled(true);
    dispatch(userChosenDuplicateQuestion(event.target.value));
    dispatch(userChosenDuplicateEntity(event.target.value));
    setErrorMessage("Duplicate_Repair_SSR044");
    if (event.target.value.split("&")[2] === "true" && (!duplicateOverridePermissions)) {
      setIsDisabled(true);
      setErrorMessage("CPR079");
    } else if (event.target.value.split("&")[0] === "In Diagnosis") {
      setIsResumeDraftRepair(true);
      setIsDisabled(false);
      setErrorMessage("CPR078");
    } else if (
      event.target.value.split("&")[0] === RepairStatusField.CatalystDefectTriage) {
      setIsResumeDraftRepair(false);
      setIsDisabled(true);
      setErrorMessage("duplicate_msg_catalyst_triage");
    }
    else if (
      event.target.value.split("&")[0] === RepairStatusField.CatalystEMATriage ||
      event.target.value.split("&")[0] === RepairStatusField.CatalystTier2Triage ||
      event.target.value.split("&")[0] === RepairStatusField.CatalystEMAStatus ||
      event.target.value.split("&")[0] === RepairStatusField.CatalystManagingAgentStatus) {
      setIsResumeDraftRepair(false);
      setIsDisabled(true);
      setErrorMessage("duplicate_msg_catalyst_triage_ema_tier2");
    }
    else if (event.target.value.split("&")[0] === "I don't think this is a duplicate") {
      if (isEmailRedirect) {
        setIsResumeDraftRepair(true);
      } else {
        setIsResumeDraftRepair(false);
      }
      setNoneOftheDuplicateSelected(true);
      setIsDisabled(false);
      if (duplicateOverridePermissions) {
        setErrorMessage("Duplicate_Repair_AdvanceRepair");
      } else {
        setErrorMessage("Duplicate_Repair_SSR045");
      }
    }
  };

  const GetErrorMessage = (errMessage: string, includeSpace: boolean) => {

    return (
      errMessage.includes("CPR079") ? (
        <>
          <div className="container w-full px-2 py-2 bg-red-20 flex items-center mb-8">
            <div className="px-4 pr-8">
              <i className="fas fa-exclamation-circle me-2 text-brick-100 w-6 h-6 bolder-font"></i>
            </div>
            <div className="div-txt-newline flex items-center text-black">
              <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                {includeSpace && " "}
                {t(errMessage)}
              </p>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="alert mb-8 p-0 container" role="alert">
            <div className="w-full px-2 py-2 bg-purple-20 flex items-center">
              <div className="px-4 pr-8">
                <i className="fa fa-bullhorn text-purple-100 w-6 h-6 purple-icon"></i>
              </div>
              <div className="flex items-center text-black">
                <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                  {includeSpace && " "}
                  {t(errMessage)}
                </p>
              </div>
            </div>
          </div>
        </>
      )
    );
  };

  const backButtonHandler = () => {
    if (isEmailRedirect) {
      props.history.push("/LandingView");
      return
    }
    dispatch(userChosenDuplicateQuestion(""));
    dispatch(userChosenDuplicateEntity(""));
   
    if (!isResumeDraftRepair && workOrderObject?.isEnhancedDiagnosticsRepair) {
      if (choosePriorityOfRepairPermission || priorityCodeValue === Helper.RepairPriorityCodes.EME) {
        props.history.push("/RepairEDEmergency");
        return;
      } else if (isHHSRSEnabled && isHHSRSRole) {
        props.history.push("/hhsrs")
        return
      }
      else {
        props.history.push("/RepairTradeCategory");
        return;
      }
    }
    else if (!isNullOrUndefined(userChosenEmergencyQuestionBackButton) && !choosePriorityOfRepairPermission) {
      if (workOrderObject?.priority === RepairPriorityCode.DampAndMouldEmergency) {
        props.history.push("/RepairLocation");
      }
      else {
        props.history.push("/RepairEmergency");
      }
    }
    else if (
      selectedRepairReason[0]?.additionalData.length > 0 &&
      selectedRepairReason[0]?.additionalData[0]?.description != ""
    ) {
      props.history.replace("/SupplementaryQuestion");
    }
    else if (!(priority === "Emergency" && selectedproperty === "Property")) {
      props.history.replace("/RepairLocation");
    }
    else if (duplicateOverridePermissions) {
      props.history.replace("/RepairLocation");
    }
    // for auto hazard duplicate repair back logic
    else if (savedHazardQuestions?.length > 0) {
      props.history.replace("/RepairAdditionalDetails");
      return;
    }

  };

  const handleBackLeave = () => {
    setIsBackModalOpen(false);
    props.history.push("/RepairTradeCategory");
  };

  const exitButtonHandler = () => {
    dispatch(backToRepairAsset(false))
    props.history.push("/LandingView");
  };

  const saveDraftAndExit = () => {
    dispatch(userChosenSaveExit(true))
    const worksOrder = new WorksOrderRequest(workOrderObject);
    dispatch(workOrderData(worksOrder))
    if (radiovalue === "") {
      dispatch(backToRepairAsset(false))
      props.history.push(`/WorkOrder360View/${worksOrder.identifiers?.worksOrderIdentifier}`);

    } else {
      setError(false);
      if (workOrderObject != null) {
        UpdateWorkOrder();
      }
      setCloseAfterSaving(true);
      dispatch(backToRepairAsset(false))
      props.history.push(`/WorkOrder360View/${worksOrder.identifiers?.worksOrderIdentifier}`);
      setTimeout(() => {
        dispatch(userChosenSaveExit(false))
      }, 6000);
    }
  };



  const UpdateWorkOrder = async () => {
    try {
      if (userDuplicateQuestion == "") {
        workOrderObject.isPotentialDuplicate = false
      } else {
        if ((duplicateOverridePermissions && noneOftheDuplicateSelected)) {
          workOrderObject.isPotentialDuplicate = false
        } else {
          workOrderObject.isPotentialDuplicate = true
        }
      }
      const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
      const woRequestParameters =
        _worksOrderRequest.updateWorkOrderParameter(workOrderObject);

      await api.updateWorkOrderRepair(
        woRequestParameters,
        workOrderObject.id,
        "eTag"
      );

      dispatch(workOrderRepairObject(workOrderObject));
    } catch (e) {
      console.error(e);
      props.history.push("/GenericError");
    } finally {
    }
  };
  const callPageHandler = async () => {
    setIsLoading(true);
    if (isResumeDraftRepair) {
      dispatch(userChosenResumeRepair(true))
      const workOrderId = radiovalue.split("&")[1];
      if (workOrderObject != null && workOrderId !== workOrderObject.id) {
        const getWorkOrderResult: any = await api.getRepair(workOrderObject.id);
        const deleteWorkOrderResponse: any = await api.deleteWorkOrder(
          workOrderObject.id,
          getWorkOrderResult?.eTag?.toString()
        );
      }
      const workOrderResponse = await api.getWorkOrderEntity(workOrderId);
      workOrderResponse.priority = (workOrderResponse.assessmentInformation?.identifier || workOrderResponse.assessmentIdentifier) && workOrderResponse.priorityCode
        ? workOrderResponse.priorityCode
        : RepairPriorityToCodeMap[workOrderResponse.priority as RepairPriority] ?? workOrderResponse.priority;
      workOrderResponse.isEnhancedDiagnosticsRepair = false;
      dispatch(setRepairDiagnosticFinalData(null));
      dispatch(userChosenEligibilityErrorCode(""));
      dispatch(workOrderRepairObject(workOrderResponse));
      await resumeRepairHandler(workOrderResponse);
    } else if (!radiovalue) {
      setErrorMessage("Duplicate_Repair_SSR055");
    }
    else {
      dispatch(userChosenResumeRepair(false));
      dispatch(userChosenDuplicateQuestion("I don't think this is a duplicate"));
      if (workOrderObject != null) {
        UpdateWorkOrder();
      }
      if (isHHSRSEnabled && isHHSRSRole && !(workOrderObject?.isEnhancedDiagnosticsRepair)) {
        props.history.push("/hhsrs")
        return
      }else {
        props.history.push("/RepairAdditionalDetails");
      }
    }
  };

  const resumeRepairHandler = async (draftRepair: any) => {
    dispatch(resetHazardAssessmentData());
    dispatch(saveEmailCopyRadioValue(""));
    dispatch(resumeDraftRepair(true));
    dispatch(isRepairMediaResume(true));
    dispatch(userChosenDuplicateEntity(""));
    let assetrResponse = null;
    const customerResponse = await api.getCustomer(draftRepair.customerIdentifier);
    //customerResponse = customerDetails
    dispatch(saveCustomerDetails(customerResponse));

    dispatch(
      saveCustomerphoneNumber(customerResponse?.addresses?.telecomsAddresses))
    dispatch(userChosenIsReporter(draftRepair?.reporterToBeContacted));
    if (draftRepair?.reporterContactDetails?.name?.givenName &&
      /^(?=.*\S)(?=.*\b(?!null\b)(?!undefined\b)\w+)/i.test(draftRepair?.reporterContactDetails.name.givenName)) {
      const name =
        draftRepair.reporterContactDetails.name.givenName.replaceAll(/\b(null|undefined)\b/g, "").trim();
      dispatch(userChosenContactPhone(draftRepair.reporterContactDetails.contactNumber))
      dispatch(userChosenContactName(name))
      dispatch(userChosenRelationDetails(draftRepair.reportedBy));
      dispatch(userChosenContactDetails(t("Provide_Number")));

    }
    else {
      dispatch(userChosenRelationDetails("Customer"));
      dispatch(userChosenContactPhone(""));
      dispatch(userChosenContactDetails(draftRepair?.reporterContactDetails?.contactNumber));
    }
    draftRepair.isDraft = true;
    dispatch(workOrderRepairObject(draftRepair));

    const {
      id,
      premisesId,
      repairLocationId,
      repairLocation,
      repairReason,
      isSupplementary,
      isEmergency,
      isPotentialDuplicate,
      additionalInformation,
      isVandalism,
      repairCauseId,
      crimeReferenceNumber,
      isVulnerable,
      VulnerableResponseText,
      isCovidSelfIsolated,
      reporterContactDetails,
      premisesUniqueReference,
      originalWorkOrderSorCode,
      priority,
      area
    } = draftRepair;
    // const area = props?.area != undefined ? props?.area : "";
    assetrResponse = await api.getAssetsByid(draftRepair.premisesId);
    dispatch(assetByIdDataObject(assetrResponse));
    if (isPotentialDuplicate) {
      dispatch(userChosenDuplicateQuestion("I don't think this is a duplicate"));
    }
    else {
      dispatch(userChosenDuplicateQuestion(""));
    }
    if (assetrResponse?.addresses?.postalAddresses[0].formattedAddress != null) {
      dispatch(userChosenPropertyAddress(assetrResponse?.addresses?.postalAddresses[0].formattedAddress));
    }
    dispatch(selectedTenacyType(area));

    const premiseType =
      area === "Block" ||
        area === "Estate" ||
        area === "Divided block"
        ? "Communal"
        : area;
    const responsedata = await api.searchRepairReasons(repairReason, premiseType, isCatalyst);
    const selectedReason = responsedata.filter(
      (reason: any) => reason.description === repairReason
    );
    dispatch(fetchRepairReasonsSelect(responsedata));
    dispatch(selectedRepairReasonObject(selectedReason));
    dispatch(priorityCode(priority));
    dispatch(selectedRepairReasonPriorityOverride(priority));
    dispatch(getMaintResp(assetrResponse?.maintenanceResponsibilities?.find(
      (responsibility: any) => responsibility.type === "MAINTSRESP"
    )?.value ?? ""));
    dispatch(getRepairResp(assetrResponse?.maintenanceResponsibilities?.find(
      (responsibility: any) => responsibility.type === selectedReason?.[0]?.element
    )?.value ?? ""));
    if (
      selectedReason[0]?.additionalData &&
      selectedReason[0]?.additionalData.length &&
      selectedReason[0]?.additionalData[0]?.description != ""
    ) {
      const resumeData = {
        resumeHLRepair: selectedReason[0]?.description,
        resumeHLSubQuestion: selectedReason[0]?.additionalData[0]?.description,
        resumeSelectedProperty: area,
        resumePriority: priority,
      };
      dispatch(userResumeData(resumeData));
    } else {
      const resumeData = {
        resumeHLRepair: "",
        resumeHLSubQuestion: "",
        resumeSelectedProperty: area,
        resumePriority: priority,
      };
      dispatch(userResumeData(resumeData));
    }
    dispatch(userChosenSOR(originalWorkOrderSorCode));
    repairLocation &&
      dispatch(userChosenRepairLocation(repairLocation)) &&
      dispatch(userChosenRepairLocationId(repairLocationId));
    repairReason && dispatch(userChosenHighLevelDescription(repairReason));
    isSupplementary === true
      ? dispatch(userChosenSupplementaryQuestions("Yes"))
      : isSupplementary === false
        ? dispatch(userChosenSupplementaryQuestions("No"))
        : dispatch(userChosenSupplementaryQuestions(""));
    dispatch(userChosenEmergencyQuestion(
      isEmergency ? t("Repair_Emergency_Radio1_Text") : "No"
    ));
    additionalInformation &&
      dispatch(userChosenAdditionalDescription(t(additionalInformation))) &&
      dispatch(
        userChosenAdditionalDescriptionCOUNT(additionalInformation.length)
      );
    isVandalism
      ? dispatch(userChosenVandalismQuestion("Yes")) &&
      dispatch(userChosenVandalismAdditionalInformation(crimeReferenceNumber))
      : dispatch(userChosenVandalismQuestion("No"));
    isVulnerable
      ? dispatch(userChosenVulnerabilityQuestion("Yes")) &&
      dispatch(
        userChosenVulnerabilityAdditionalInformation(VulnerableResponseText)
      )
      : dispatch(userChosenVulnerabilityQuestion("No"));
    isCovidSelfIsolated === true
      ? dispatch(userChosenCovidQuestion("Yes"))
      : isCovidSelfIsolated === false
        ? dispatch(userChosenCovidQuestion("No"))
        : dispatch(userChosenCovidQuestion(""));
    const resumeDraftDataCache = {
      repairLocation,
      repairLocationId,
      repairReason,
      supplementaryQuestions:
        isSupplementary === true
          ? "Yes"
          : isSupplementary === false
            ? "No"
            : "",
      emergencyQuestion: isEmergency && t("Repair_Emergency_Radio1_Text"),
      additionalInformation,
      vandalismQuestion: isVandalism ? "Yes" : "No",
      crimeReferenceNumber: isVandalism ? crimeReferenceNumber : "",
      vulnerabilityQuestion: isVulnerable ? "Yes" : "No",

      vulnerableResponseText: isVulnerable ? VulnerableResponseText : "",
      covidQuestion:
        isCovidSelfIsolated === true
          ? "Yes"
          : isCovidSelfIsolated === false
            ? "No"
            : "",
      reporterContactDetails,
    };
    dispatch(userResumeDraftDataCache(resumeDraftDataCache));
    const HHSRSAssessment = draftRepair?.hhsrsAssessment;
    const hasCompletedHHSRSAssessment = Boolean(draftRepair?.assessmentInformation?.outcome);
    dispatch(saveHazardType(HHSRSAssessment?.category));
    dispatch(saveSaverityScore(HHSRSAssessment?.severity));
    dispatch(saveHHSRSOption(hasCompletedHHSRSAssessment));
    dispatch(saveHHSRSAssessmentCompleted(hasCompletedHHSRSAssessment));
    if (
      isHHSRSRepairEnabled === true &&
      (selectedReason?.[0]?.isHazard === true || selectedReason?.[0]?.isPreAssessmentRequired === true)
    ) {
      props.history.push("/RepairLocation");
      return;
    }
    if (!repairLocation || !repairReason) {
      props.history.replace("/RepairLocation");
    }

    else if (!additionalInformation) {
      if (isSupplementary === null && isPotentialDuplicate !== true) {
        props.history.push("/SupplementaryQuestion");

      } else if (isEmergency !== true && isEmergency !== false && isPotentialDuplicate !== true && !choosePriorityOfRepairPermission) {
        props.history.push("/RepairEmergency");
      }
    }
    else if (additionalInformation.trim().length > 0 && comingFromConfirmedDampmould) {
      props.history.push("/ConfirmedDampMould");
    }
    else if (additionalInformation.trim().length > 0 && comingFromDampAndMouldAssesment1) {
      props.history.push("/DampAndMouldAssesment/1");
    }
    else if (additionalInformation.trim().length > 0 && comingFromDampAndMouldAssesment2) {
      props.history.push("/DampAndMouldAssesment/2");
    }
    else if (additionalInformation.trim().length > 0 && comingFromDampAndMouldAssesment3) {
      props.history.push("/DampAndMouldAssesment/3");
    }
    else if (additionalInformation.trim().length > 0 && isComesFromMediaPage === true) {
      props.history.push("/RepairUploadmedia");
    }
    else if (userChosenAdditionalDescriptionBackButton !== "" || additionalInformation.trim().length > 0) {
      if (isHHSRSEnabled && isHHSRSRole && !(workOrderObject?.isEnhancedDiagnosticsRepair)) {
        props.history.push("/hhsrs");
      } else {
        props.history.push("/RepairAdditionalDetails");
      }
    }
    else if (isVandalism === null && (assetDetails?.statuses.isInDefects === true && vandalismConfigValue === true)) {
      props.history.push("/VandalismQuestion");
    } else if (isVulnerable === null) {
      props.history.push("/VulnerabilityQuestion");
    }
    else if (isVulnerable === true && VulnerableResponseText === null) {
      props.history.push("/VulnerabilityQuestion");
    }


    else if (area === "Property" && isCovidSelfIsolated === null && covidConfigValue) {
      props.history.push("/CovidQuestion");
    }
    else if (reporterContactDetails != null) {

      if (draftRepair.reporterContactDetails?.name?.givenName?.trim()?.length === 0 || draftRepair.reporterContactDetails?.contactNumber?.trim()?.length === 0 || draftRepair.reporterContactDetails?.name === null) {

        if (isCovidSelfIsolated === null && covidConfigValue) {
          draftRepair.reporterContactDetails.name = null;
          props.history.push("/CovidQuestion");
        }
        else {
          draftRepair.reporterContactDetails.name = null;
          props.history.push("/CustomerDetails");
        }
      }
      else {
        draftRepair.reporterContactDetails.name = null;
        props.history.push("/ConfirmationDetails");
      }
    }
    else if (draftRepair.reportedBy.trim().length <= 0) {
      props.history.push("/CustomerDetails");
    }
    else {

      if (draftRepair.reporterContactDetails != null) {
        const name = draftRepair.reporterContactDetails?.name?.givenName?.trim();
        dispatch(userChosenContactPhone(draftRepair.reporterContactDetails.contactNumber))
        dispatch(userChosenContactName(name))
        dispatch(userChosenRelationDetails(draftRepair.reportedBy));
        dispatch(userChosenContactDetails("I would like to provide number for this repair."));
      }
      else {
        dispatch(userChosenRelationDetails("Customer"));
        dispatch(userChosenContactPhone(customerResponse?.addresses?.telecomsAddresses?.[0].number));
        dispatch(userChosenContactDetails(customerResponse?.addresses?.telecomsAddresses?.[0].number));
      }
      props.history.push("/ConfirmationDetails");
    }
  };

  const showHLDescriptionMessage = (index: number) => {
    setShowHLDescription(prevState => prevState.map((item, idx) => idx === index ? !item : item))
  }

  const getWOUnderReviewStatus = (woUnderReviewToBeDetermined: any) => {
    return (woUnderReviewToBeDetermined?.statuses?.status === "In Diagnosis" &&
      (woUnderReviewToBeDetermined?.statuses.isPotentialDuplicate === true ||
        woUnderReviewToBeDetermined?.statuses.isVulnerable === true ||
        woUnderReviewToBeDetermined?.job.sorCode === "N/A" || woUnderReviewToBeDetermined?.job.sorCode === "NA" ||
        woUnderReviewToBeDetermined?.job.description.includes("heating or hot water")))
  }

  const getPriorityName = (item: any) => {
    if (item.statuses.isEmergency && item.job.priority?.code != RepairPriorityCode.DampAndMouldEmergency) {
      if (item.statuses.isOutOfHours) {
        return RepairPriority.EmergencyOOH;
      } else {
        return RepairPriority.Emergency;
      }
    }
    const priorityName = PriorityCodeAndNames
      .find(p => p.key === item.job?.priority?.code)?.value
      || RepairPriority.NextAvailable;

    return priorityName;
  }

  const alldata = (item: any, index: any) => {
    const triageStatus = getWOUnderReviewStatus(item);

    return (
      <div className="row rounded-lg mb-4">
        <div className="columnRadio">
          <FormControlLabel
            id="duprepair-label1"
            key={index}
            control={<Radio key={item.identifiers.worksOrderIdentifier} id="duprepair-radio1" name={item.identifiers.worksOrderIdentifier} data-testid={item.identifiers.worksOrderIdentifier} title="" role="radio" />}
            value={item.statuses.status + "&" + item.identifiers.worksOrderIdentifier + "&" + triageStatus}
            label=""
            aria-label="tableDup"
            className="global-txt"
          />
        </div>
        <div className="dupDiv bordertable mb-2 divLeft parent">
          <div className="colLocation divRight">
            <h6 className="headDiv">{t("Date_Creation")}</h6>
            <p className="bdyDiv">{moment(item.raisedDate).format("MMMM Do YYYY, h:mm:ss A")}</p>
          </div>
          <div className="columnDes divRight">
            <div className="flex"><h6 className="headDiv flex-item-left">{t("High_Level_Description")}</h6>
              <div className="bdyDiv flex-item-right div-mr-left mt-1" onClick={(e: any) => showHLDescriptionMessage(index)} onKeyPress={(e: any) => showHLDescriptionMessage(index)}> {showHLDescription[index] ? "x" : "+"}</div>
            </div>
            <p className="bdyDiv">{
              item.channel != RepairChannel.CustomerSelfService &&
                item.channel != RepairChannel.ERGO &&
                item.channel != RepairChannel.ColleagueSelfServe
                ? (item.job.trade == "Unknown" ? t("RepairDescription_ErrorMessage") : item.job.trade)
                : item.job.description?.split(".")[0]
            }</p>
            {showHLDescription[index] && <p>{
              item.channel != RepairChannel.CustomerSelfService &&
                item.channel != RepairChannel.ERGO &&
                item.channel != RepairChannel.ColleagueSelfServe
                ? item?.job?.description || "-" : item?.job?.description?.split(".")[1] || "-"
            }</p>}
          </div>
          <div className="colLocation divRight">
            <h6 className="headDiv">{t("Location")}</h6>
            <p className="bdyDiv">{item.job.location.location}</p>
          </div>
          <div className="column divRight" >
            <h6 className="headDiv">{t("WO Reference")}</h6>
            <p className="bdyDiv workorderLink" onClick={(e: any) => window.open(`/WorkOrder360View/${item?.identifiers?.worksOrderIdentifier}`, "_blank")} onKeyPress={(e: any) => window.open(`/WorkOrder360View/${item?.identifiers?.worksOrderIdentifier}`, "_blank")}>{item?.identifiers?.jobNumber || "View details"}</p>
          </div>
          <div className="column divRight" data-testid="PriorityValue">
            <h6 className="headDiv">{t("Priority_txt")}</h6>
            <p className="bdyDiv">{getPriorityName(item)}</p>
          </div>
          <div className="column mob-div">
            <h6 className="headDiv">{t("Status_txt")}</h6>
            <p className="bdyDiv">
              {(() => {
                if (item.statuses.status === RepairStatusField.InDiagnosis && item.statuses.isRaisedAsTriage) {
                  return "Under review";
                }
                if (item.statuses.status === RepairStatusField.InDiagnosis) {
                  return "Draft";
                }
                if (item.statuses?.status === RepairStatusField.ReportedToEMA) {
                  return t("assigned_contractor");
                }
                if (item.statuses?.status === RepairStatusField.CatalystManagingAgentStatus) {
                  return RepairStatusField.CatalystEMAStatus;
                }
                return item.statuses.status;
              })()}
            </p>
          </div>

        </div>
      </div>
    );


  };

  return (
    <Container id="duprepair-container" role="main" className="ctn-fht">
      <div id="backmodal-div1" className="container mx-auto mb-0 md:mb-14 lg:mb-10 px-0 xl:px-0" >
        <div className="back-and-journey">
          <p id="backmodal-p" className="text-teal text-xl mt-4 mb-8 md:mb-12 ml-2">
            <button className="back-btn" onClick={backButtonHandler}>
              <i className="fas fa-angle-left mr-2"></i>
              <span>{t("back")}</span>
            </button>
          </p>
          <ExitModalAndSave
            id="duprepair-back-exitmodal"
            open={isBackModalOpen}
            modalTitle={t("BACKMODALTITLE")}
            modalSubtitle={t("BACKMODALSUBTITLE")}
            stayButtonText={t("STAYBUTTONTEXT")}
            leaveButtonText={t("LEAVEBUTTONTEXT")}
            closeAfterSaving={false}
            canSaveAndExit={false}
            showBackOnly={true}
            onLeave={handleBackLeave}
            onClose={() => setIsBackModalOpen(false)}
          />
          <div className=""></div>
          {<RepairJourney />}
        </div>
      </div>
      {!isLoading ? (
        <>
          <div className="container">
            <div id="duprepair-label2" className="h5 my-4 ml-2">
              {" "}
              <p className="text-purple-100 text-2xl mb-4 global-txt">
                {t("Duplicate_Repair_CPR015")}{" "}
              </p>
            </div>
            <div
              id="duprepair-div3"
              className="mb-4 text-base repair-text global-txt ml-2"
            >
              <p>{t("Duplicate_Repair_CPR016")}</p>
            </div>


            <RadioGroup
              id="duprepair-radiogroup"
              onChange={handleRadioChange}
              data-testid="none-of-above"
              value={radiovalue}
              className="question-btn "
            >
              {duplicateRepairResult && duplicateRepairResult?.totalCount > 0
                && duplicateRepairResult?.worksOrders?.sort(
                  (a: any, b: any) =>
                    new Date(b.raisedDate).valueOf() -
                    new Date(a.raisedDate).valueOf()
                ).map(alldata)}

              <fieldset><legend>
                <FormControlLabel
                  id="duprepair-label1"
                  className="mt-4"
                  control={
                    <Radio
                      key={radiovalue}
                      id="duprepair-radio2"
                      data-testid="NoneOfTheAbove"
                      placeholder="NoneOfTheAbove"
                      aria-label={t("NOTA")} className="global-txt "
                    />
                  }
                  label={t("NOTA")}
                  value={t("IDT_its_duplicate")}
                />
              </legend></fieldset>
            </RadioGroup>
          </div>
          {error && !disableContinueforEnhancedEligiblityCheck ? GetErrorMessage(errorMessage, true) : <div></div>}
          {disableContinueforEnhancedEligiblityCheck && (
            <div
              data-testid="alert-warning"
              className="error mb-8 sm:mx-1"
              role="alert"
              placeholder="alert-message"
            >
              <div className="w-full px-2 py-2 bg-yellow flex items-center">
                <div className="px-4 pr-8">
                  <i className="fas fa-exclamation-triangle text-brick-70 w-6 h-6"></i>
                </div>
                <div className="flex items-center">
                  <p
                    data-testid="locatioAlert_0"
                    className="w-full text-left my-2 font-AvantGardeGothic-Md"
                  >
                    {" "}
                    {t(showError)}
                  </p>
                </div>
              </div>
            </div>
          )}

          <div
            id="duprepair-main-btn"
            className="flex justify-between items-center pb-4 md:pb-8 container"
          >
            <ExitModalAndSave
              id="duprepair-exitmodal"
              exit={exitButtonHandler}
              saveDraftAndExit={saveDraftAndExit}
              closeAfterSaving={closeAfterSaving}
            />
            <Button
              id="duprepair-btn1"
              onClick={callPageHandler}
              disabled={isDisabled}
              className="button-class"
            >
              {t("continue")}
              <i className="fas fa-angle-right relativetext-white pointer-events-none arrow"></i>
            </Button>
          </div>
        </>
      ) : (
        <div className="div-loader">
          <div className="SpinnerWrapper">
            <LoadingSpinner />
          </div>
        </div>
      )
      }
    </Container>
  );
};
export default DuplicateRepair;
